import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";

import {
  Card,
  Table,
  Stack,
  Paper,
  Button,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TableHead,
  CircularProgress,
  Box,
  IconButton,
  Popover,
  MenuItem,
} from "@mui/material";
import Iconify from "../components/iconify";
import { get, del } from "src/utils/networkUtils";
import { useNavigate } from "react-router-dom";
import { fDateTime } from "src/utils/formatTime";
import DeleteDialog from "src/components/leagues-admin/DeleteDialog";
import { getStatusName } from "src/utils/inboxUtils";
import { getUserPermissions } from "src/utils/permissionsUtils";

export default function AdminInboxMessagesPage() {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(null);
  const [openId, setOpenId] = useState(null);
  const [showDeleteMessageDialog, setShowDeleteMessageDialog] = useState(false);
  const [deleteMessage, setDeleteMessage] = useState(null);
  const { isViewer } = getUserPermissions();

  useEffect(() => {
    get(`/admin/inbox-messages?offset=0&limit=20`).then(function (response) {
      setRows(response.adminInboxMessages);
      setLoading(false);
    }, []);
  }, []);
  const handleOpenMenu = (event) => {
    setOpen(event.currentTarget);
    setOpenId(event.currentTarget.id);
  };

  const handleCloseMenu = () => {
    setOpen(null);
    setOpenId(null);
  };
  const deleteMessageHandler = (id) => {
    setLoading(true);
    setOpen(null);
    del(`/admin/inbox-messages/${id}`).then(function (response) {
      setShowDeleteMessageDialog(false);
      setDeleteMessage(null);
      setOpen(null);
      setOpenId(null);
      window.location.reload(false);
    });
  };
  const openDeleteMessageDialog = (id) => {
    setDeleteMessage(id);
    setShowDeleteMessageDialog(true);
  };
  return (
    <>
      <Helmet>
        <title> Inbox </title>
      </Helmet>

      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={1}
        >
          <Typography variant="h4" gutterBottom>
            Inbox
          </Typography>
          <Button
            sx={{ mr: 2 }}
            variant="contained"
            startIcon={<Iconify icon="eva:plus-fill" />}
            onClick={() => navigate("/dashboard/inbox/message")}
          >
            Create New Message
          </Button>
        </Stack>
        <Card>
          {loading ? (
            <Box
              sx={{ display: "flex", justifyContent: "center" }}
              style={{ padding: 20 }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell align="center">ID</TableCell>
                    <TableCell align="center">Publish Date</TableCell>
                    <TableCell align="center">Subject</TableCell>
                    <TableCell align="center">Message Sent</TableCell>
                    <TableCell align="center">Message Read</TableCell>
                    <TableCell align="center">Status</TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows?.map((row, index) => (
                    <TableRow
                      key={index}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                      }}
                    >
                      <TableCell component="th" scope="row" align="center">
                        {row.adminInboxMessageId}
                      </TableCell>
                      <TableCell component="th" scope="row" align="center">
                        {fDateTime(row.publishAt)}
                      </TableCell>
                      <TableCell component="th" scope="row" align="center">
                        {row.subject}
                      </TableCell>
                      <TableCell component="th" scope="row" align="center">
                        {`${row.messagesSentCount} / ${row.size}`}
                      </TableCell>
                      <TableCell component="th" scope="row" align="center">
                        {row.messagesReadCount}
                      </TableCell>
                      <TableCell component="th" scope="row" align="center">
                        {getStatusName(row)}
                      </TableCell>
                      <TableCell align="right">
                        <IconButton
                          size="large"
                          color="inherit"
                          onClick={handleOpenMenu}
                          id={row.adminInboxMessageId}
                        >
                          <Iconify icon={"eva:more-vertical-fill"} />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </Card>
      </Container>
      {!isViewer && (
        <Popover
          open={Boolean(open)}
          anchorEl={open}
          onClose={handleCloseMenu}
          anchorOrigin={{ vertical: "top", horizontal: "left" }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
          PaperProps={{
            sx: {
              p: 1,
              width: 160,
              "& .MuiMenuItem-root": {
                px: 1,
                typography: "body2",
                borderRadius: 0.75,
              },
            },
          }}
        >
          <MenuItem
            onClick={() =>
              navigate(`/dashboard/inbox/message?message_id=${openId}`)
            }
          >
            <Iconify icon={"eva:edit-outline"} sx={{ mr: 2 }} />
            Edit
          </MenuItem>

          <MenuItem onClick={() => openDeleteMessageDialog(openId)}>
            <Iconify icon={"eva:trash-outline"} sx={{ mr: 2 }} />
            Delete
          </MenuItem>
        </Popover>
      )}

      <DeleteDialog
        openConfirm={showDeleteMessageDialog}
        setOpenConfirm={setShowDeleteMessageDialog}
        questionIndex={deleteMessage}
        deleteGameHandler={deleteMessageHandler}
        title={"Delete Message"}
        description={"Are you sure you want to delete this message?"}
      />
    </>
  );
}
